import { FC, useEffect } from 'react';
import FileUploaderTile from '@views/AdminPage/ImportMedications/FileUploaderTile';
import FileUploader from '@views/AdminPage/ImportMedications/FileUploader/FileUploader';
import { EventType } from '@utils/eventBus';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  removeAdminImportIngredientsCleanUpList
} from '@store/features/adminImportMedications/slice';

import useDispatch from '@store/hooks/useDispatch';
import {
  adminImportIngredientsCleanUpListErrorsSelector,
  adminImportIngredientsCleanUpListLoadingSelector,
} from '@store/features/adminImportMedications/selectors';
import { handleAdminImportIngredientsCleanUpList } from '@store/features/adminImportMedications/actions';

const ImportIngredientsCleanUpList: FC = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isLoadingIngredientsCleanupList = useSelector(adminImportIngredientsCleanUpListLoadingSelector);
  const errorsIngredientsCleanupList = useSelector(adminImportIngredientsCleanUpListErrorsSelector);
  const hasErrorsIngredientsCleanupList = errorsIngredientsCleanupList.length > 0;

  useEffect(() => {
    dispatch(removeAdminImportIngredientsCleanUpList());
  }, []);

  return <FileUploaderTile title={t('admin.importIngredientsCleanUpHeader')}>
    <FileUploader
      className="import-medications__file-uploader"
      importHandler={handleAdminImportIngredientsCleanUpList}
      errors={errorsIngredientsCleanupList}
      eventType={EventType.ADMIN_IMPORT_INGREDIENTS_CLEANUP_LIST_SUCCESS}
      hasErrors={hasErrorsIngredientsCleanupList}
      isLoading={isLoadingIngredientsCleanupList}
      successMessage={t('admin.importIngredientsCleanUpSuccess')}
    />
  </FileUploaderTile>;
};

export default ImportIngredientsCleanUpList;
